// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { Button, Loader } from '@mantine/core';

import { MissingFeatureModal } from 'components/Mantine/MissingFeatureModal';
import { FormModal } from 'components/Mantine/Modals/FormModal';

import { ManageRevitRoles } from './ManageRevitRoles';
import type { RoleAndPermissionModalContentsProps } from './types';

export const ManageRevitRolesModal = (props: RoleAndPermissionModalContentsProps) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Button variant="light" onClick={() => setOpened(true)}>
        Manage Revit Roles
      </Button>

      {props.hasRevitRoles && (props.hasMechanical || props.hasElectrical) ? (
        <FormModal
          title="Manage Revit Roles"
          opened={opened}
          onClose={() => setOpened(false)}
          size={850}
          withCloseButton={false}
          type="submit"
        >
          {props.company ? <ManageRevitRoles {...props} company={props.company} /> : <Loader />}
        </FormModal>
      ) : (
        <MissingFeatureModal
          type={
            props.hasRevitRoles
              ? {
                  messageType: 'plainText',
                  data: 'This feature requires an EVOLVE Electrical or EVOLVE Mechanical license',
                }
              : { messageType: 'platformMessage', data: 'MissingRevitRolesLicense' }
          }
          opened={opened}
          onClose={() => setOpened(false)}
        />
      )}
    </>
  );
};
